import { memo } from "react"
import Parallax from "ui/parallax/Parallax"

type Props = {}

const Hero = ({}: Props) => {
  return (
    <Parallax
      slides={[
        {
          id: 1,
          image: "images/fortpeat.jpg",
        },
        {
          id: 2,
          image: "images/phomas-kong-auau-save.jpg",
        },
        {
          id: 3,
          image: "images/up-poom.jpg",
        },
      ]}
    />
  )
}

export default memo(Hero)
